// 행군 막대의 메테오 (채택된 제품 장치, 사용자 2026-10-14 「매우 강함 채택.」)
//
// ── 무엇이고 어디서 왔나 ──────────────────────────────────────────────────────
//
// 열람 화면 attack 카드의 행군 막대는 끝에 작은 메테오(청백 중심과 푸른 꼬리)가 달려 날아가고, 착탄 순간 끝점에서 빛이 퍼진다.
// 처음에는 사용자가 8990 에서 약함, 강함, 매우 강함을 견주려고 주소 쿼리와 탭 저장소로 켜던 미리보기였다(2026-10-14 사용자 지시).
// 사용자가 매우 강함을 골랐고(같은 날), 그래서 그 모양 하나만 모든 열람자에게 기본으로 그린다. 쿼리, 탭 저장소, 약함과 강함, 끔(옛
// 막대), 미리보기 페이지는 걷었다. 걷은 파일은 커밋하지 않았다.
//
// 사용자가 이 채택과 함께 정한 것(2026-10-14 질문과 답):
//   - 착탄 뒤 침강을 확산 시간(0.9초)만큼 늦추는 것을 그대로 둔다(「0.9초 늦춤 유지」).
//   - 오렌지 채움 위를 1.4초마다 달리는 빛 훑기를 남긴다(「남김」). 「독립 타이머 금지」는 메테오 위치에 대한 지시로 읽는다.
//   - 메테오 때문에 행군 카드가 10px 커지는 것을 받아들인다(「+10px 수용」).
//   - 메테오 전용 되돌림 조건은 두지 않는다(「조건 없이 채택」). 관측에서 문제가 나오면 그때 정한다.
// 모든 열람자에게 기본으로 켜고 움직임 줄이기 설정이면 정적으로 그리는 범위는 세션 해석이고, 사용자는 이의를 달지 않았다.
//
// 모양(머리, 꼬리, 불티, 훑기, 맥동, 착탄 여섯 겹)은 전부 `index.css` 의 메테오 블록이 진다. 이 파일은 시각에서 무엇을 파생하는지만 진다.
//
// ── 위치의 출처는 하나다 ────────────────────────────────────────────────────
//
// 메테오 머리는 `marchProgress`(서버 보정 시각에서 파생한 행군 진행률) 값 하나로만 선다. 자기 타이머도, 프레임 루프도,
// 자기 시각 계산도, 보간도 없다. 열람 화면이 이미 다시 그리는 주기(약 0.1초)마다 그 순간의 진행률 자리에 바로 선다. 그래서
// retime, 재접속, 탭 복귀, 시계 재수렴 뒤의 첫 그리기도 곧바로 올바른 자리이고, 큰 뜀을 따로 가려낼 일이 없다.
//
// 처음 판은 그리기 사이를 위치 이동 값의 짧은 보간으로 잇고 큰 뜀에서만 끊었다. 그런데 그리기마다 보간을 새로 거는 일이 매 프레임
// 스타일 재계산을 불렀고(2026-10-14 측정, 같은 조건의 작은 페이지에서 보간을 0.1초마다 다시 걸면 1.5초에 61번, 걸지 않으면 0번),
// 4분 행군에서 한 그리기의 이동은 약 0.1px 라 보간이 눈에 주는 것이 없었다. 그래서 걷었다.
//
// 불티, 훑기, 맥동, 꼬리 일렁임은 머리 자리를 옮기지 않는 장식 반복이라 자기 주기로 돈다. 위치의 출처는 그래도 진행률 하나다.
//
// ── 착탄 확산도 시각에서 파생한다 ──────────────────────────────────────────────
//
// 확산은 착탄 시각에서 지난 만큼을 음수 지연으로 주어 시작한다. 그래서 탭 복귀나 재접속 때 처음부터 다시 터지지 않고, 확산
// 시간이 이미 지났으면 아예 그리지 않는다. 확산이 보이는 동안만 카드는 행군 모양을 지키고, 확산이 끝나면 기존 착탄 뒤
// 모양(sunk 면, 막대 없음)과 정렬(목록 끝)이 그대로 선다. `data-phase` 는 그 동안에도 시각 그대로의 단계(impacted)다.
//
// 확산은 착탄 하나에 한 번만 열린다(`gateBurst`). 창이 열릴 때 탭이 가려져 있거나 attack 칸이 감춰져 있으면 확산 없이 곧바로
// 침강하고, 보정 시각이 착탄 앞으로 잠깐 물러났다 다시 넘어도 다시 터지지 않는다. 행군 구간이 없던 줄(행군 시간 0)은 막대가 한 번도
// 없었으니 확산도 없다(`cards.tsx`). 셋 다 2026-10-14 반증 지적으로 더했다.

import { useSyncExternalStore } from 'react'

import type { Phase } from './phase.ts'

/**
 * 착탄 확산 시간(밀리초). 섬광, 충격파 고리, 빛줄기, 파편, 되짚는 빛, 잔광이 차례로 지나가는 길이다. 섬광은 약 0.3초 밝기를 지키다
 * 0.45초에, 빛줄기는 0.4초에 끝나고 잔광이 끝까지 남는다. 착탄한 카드가 행군 모양을 지키는 시간(침강 늦춤)도 이 값이다(사용자
 * 2026-10-14 「0.9초 늦춤 유지」).
 *
 * 모양은 `index.css` 가 지지만 이 시간만 여기 둔다. 카드가 행군 모양을 얼마나 더 지킬지를 렌더가 정하기 때문이다. 확산 상자의
 * 애니메이션 시간도 렌더가 이 값으로 인라인 스타일에 적는다(한 값을 두 자리에 적지 않는다).
 */
export const METEOR_BURST_MS = 900

/**
 * 메테오를 태운 층을 얼마나 왼쪽으로 물릴지(퍼센트). 층의 폭이 트랙 폭과 같고 머리가 층의 오른쪽 끝에 붙으므로,
 * 진행률 p 에서 `(p − 1) × 100%` 만큼 물리면 머리가 트랙의 p 지점, 곧 채움의 끝에 선다.
 */
export function riderShiftPercent(progress: number): number {
  const p = Math.min(1, Math.max(0, progress))
  return (p - 1) * 100
}

/**
 * 착탄 확산이 지금 보이는가. 보이면 착탄에서 지난 밀리초, 아니면 null.
 * 움직임 줄이기에서는 언제나 null 이다(확산도, 그만큼의 침강 늦춤도 없다).
 */
export function burstElapsed(impactMs: number, nowMs: number, reduced: boolean): number | null {
  if (reduced) return null
  const elapsed = nowMs - impactMs
  if (elapsed < 0 || elapsed >= METEOR_BURST_MS) return null
  return elapsed
}

/** 확산을 착탄 하나에 한 번만 열려고 기억하는 표. 열쇠는 `burstKey`, 값은 지금 보이는 중인지 이미 끝났는지다. */
export type BurstMemo = Map<string, 'showing' | 'done'>

/** 기억 표의 열쇠. retime 으로 착탄 시각이 바뀌면 다른 착탄이다. */
export function burstKey(rallyId: string, impactMs: number): string {
  return `${rallyId}@${String(impactMs)}`
}

/**
 * 시각에서 파생한 확산 창(`burstElapsed` 의 값)을 착탄 하나에 한 번만 열리게 거른다. 돌려주는 값은 그리기에 쓸 경과이고, 없으면 null 이다.
 *
 * 1. 창이 닫혔는데 보이던 중이었으면 끝난 것으로 적는다. 보정 시각이 착탄 앞으로 잠깐 물러났다 다시 넘어도 두 번 터지지 않는다
 *    (2026-10-14 반증 지적, 다시 넘을 때는 확산 없이 곧바로 침강한다).
 * 2. 확산을 볼 수 없는 자리(가려진 브라우저 탭, defense 탭 아래 감춰진 attack 칸)에서 창이 열리면 확산 없이 끝난 것으로 적는다.
 *    가려진 동안 확산 요소가 경과를 얼린 채 남았다가 돌아온 첫 화면에서 늦게 번쩍이거나, 감춰진 칸에서 시작하지 못한 애니메이션이
 *    탭을 옮긴 순간 밝은 채 잘리는 일을 막는다(같은 지적). 그 줄은 곧바로 침강하고, 창 안에 돌아와도 다시 열지 않는다.
 * 3. 끝난 것으로 적힌 착탄은 다시 열지 않는다.
 *
 * 같은 입력으로 여러 번 불러도 답이 같다(개발 모드의 두 번 그리기와 정렬 비교가 같은 줄을 여러 번 물어도 된다).
 */
export function gateBurst(memo: BurstMemo, key: string, elapsed: number | null, unseen: boolean): number | null {
  const state = memo.get(key)
  if (elapsed === null) {
    if (state === 'showing') memo.set(key, 'done')
    return null
  }
  if (unseen || state === 'done') {
    memo.set(key, 'done')
    return null
  }
  memo.set(key, 'showing')
  return elapsed
}

/** 지금 목록에 없는 착탄의 기억을 걷는다(retime 으로 열쇠가 쌓이지 않게). */
export function pruneBurstMemo(memo: BurstMemo, live: ReadonlySet<string>): void {
  for (const key of [...memo.keys()]) {
    if (!live.has(key)) memo.delete(key)
  }
}

/**
 * 화면에 보일 모양의 단계. 확산이 보이는 동안만 착탄 뒤 카드가 행군 모양(live 면, 막대, 제자리)을 지킨다.
 * 그 밖에는 시각 그대로의 단계와 같다. 움직임 줄이기에서는 확산이 없어 언제나 같다.
 */
export function lookOf(phase: Phase, burst: number | null): Phase {
  return phase === 'impacted' && burst !== null ? 'marching' : phase
}

/** 움직임 줄이기 질의. */
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

function reducedMedia(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null
  return window.matchMedia(REDUCED_MOTION_QUERY)
}

function subscribeReduced(onChange: () => void): () => void {
  const media = reducedMedia()
  if (media === null) return () => undefined
  media.addEventListener('change', onChange)
  return () => {
    media.removeEventListener('change', onChange)
  }
}

function readReduced(): boolean {
  return reducedMedia()?.matches ?? false
}

/** 기기의 움직임 줄이기 설정. 바뀌면 다시 그린다. 서버 렌더(시험)에서는 꺼짐이다. */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribeReduced, readReduced, () => false)
}

function subscribePageHidden(onChange: () => void): () => void {
  if (typeof document === 'undefined') return () => undefined
  document.addEventListener('visibilitychange', onChange)
  return () => {
    document.removeEventListener('visibilitychange', onChange)
  }
}

function readPageHidden(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden'
}

/** 브라우저 탭이 가려져 있는가. 바뀌는 순간 다시 그려 확산 기억(`gateBurst`)이 그때 바로 닫힌다. 서버 렌더(시험)에서는 보이는 쪽이다. */
export function usePageHidden(): boolean {
  return useSyncExternalStore(subscribePageHidden, readPageHidden, () => false)
}
